function footerMenuBehavior() {
  const isDesktop = window.matchMedia('(min-width: 991px)').matches;
  const detailsElements = document.querySelectorAll('.custom-footer__menu details');

  detailsElements.forEach((details) => {
    if (isDesktop) {
      details.setAttribute('open', '');
    } else {
      details.removeAttribute('open');
    }
  });
}

document.addEventListener('DOMContentLoaded', footerMenuBehavior);
window.addEventListener('resize', footerMenuBehavior);

